import FormulateCssClassService from '@/Services/FormulateCssClassService/FormulateCssClassService';

class InputCssClassService extends FormulateCssClassService {
    public process(): void {
        if (this.isText()) {
            this.fullwidth();
            this.addClass('rounded-lg')
            if (this.hasErrors()) {
                this.addClass([
                    'border-red-200',
                    'border-2',
                ])
            }
        }

        if(this.isSelect()) {
            this.fullwidth();
            this.addClass('rounded-lg')
        }

        if(this.isSlider()) {
            this.fullwidth();
        }

        if (this.isTextarea()) {
            this.addClass([
                'min-h-40',
                'rounded',
            ])
        } else if (this.isBox()) {
            this.addGroupedClass([
                'sr-only',
            ])
            this.addClass('mb-2')
        }

    }
}

export default InputCssClassService
